module.exports = __webpack_public_path__ + "static/img/fabrication_3.00e8540.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fabrication_3.jpg
// module id = Gvc6
// module chunks = 0